<template>
  <app-content>
    <h1>About</h1>
    <div class="my-name">{{ name }}</div>
    <div class="information-items">
      <div class="item" v-for="information in informations" :key="information.id">
        <span class="label" v-html="information.label"></span>
        <span class="content" v-html="information.content"></span>
      </div>
    </div>
    <div class="text-block" v-html="text" />
    <div class="text-block-label">略歴</div>
    <div class="text-block biography" v-html="biography" />
    <div class="works-link">
      <leading-link to="/works" size="32">Works</leading-link>
    </div>
  </app-content>
</template>

<script>
import AppContent from 'src/components/AppContent'
import LeadingLink from 'src/components/LeadingLink'
import data from './data'

export default {
  data: () => {
    return {
      ...data
    }
  },
  components: {
    AppContent,
    LeadingLink
  }
}
</script>

<style scoped>
.my-name {
  font-size: 1.3em;
  margin: 24px 0;
}

.information-items {
  display: flex;
  margin: 24px 0;
  flex-direction: column;
  border-top: 1px dashed rgb(117, 117, 117);
}

.information-items .item {
  display: flex;
  flex-direction: row;
  border-bottom: 1px dashed rgb(117, 117, 117);
}

.information-items .item .label {
  width: 20%;
  min-width: 70px;
  padding: 24px;
}

.information-items .item .content {
  width: 80%;
  padding: 24px;
}

.text-block-label {
  margin-bottom: 16px;
}

.text-block {
  margin-bottom: 24px;
}

.biography {
  font-size: 0.8em;
}

.works-link {
  display: flex;
  margin-top: 64px;
  margin-bottom: 64px;
  justify-content: center;
}

@media screen and (max-width: 480px) {
  .information-items .item .label {
    padding: 24px 8px;
  }

  .information-items .item .content {
    padding: 24px 8px;
  }
}
</style>
